
import { defineComponent } from 'vue';
import { api } from "@/common/api";
import { BimgxUrlUtil } from "@/common/bimgx-url.util";

export default defineComponent({
    name: "WechatWxmpRobot",
    data() {
        return {
            isLogin: false,
            qrcodeUrl: "",
        };
    },

    async mounted() {
        await this.checkLogin();
    },

    methods: {
        async checkLogin() {
            this.qrcodeUrl = "";
            
            let tRes = await api.get("wxmp/is-login");
            this.isLogin = tRes.data["isLogin"];
        },

        async login() {
            let tRes = await api.get("wxmp/login");
            let qrcodeUrl = tRes.data["qrcodeUrl"];
            this.qrcodeUrl = BimgxUrlUtil.getRealUrl(qrcodeUrl);
        },
    },
});
